// src/client.ts
import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";

// src/services/report/report.shared.ts
var reportPath = "/report/v1/:tenantId";
var reportMethods = ["executeReport", "fireReport"];
var reportClient = (client) => {
  const connection = client.get("connection");
  client.use(reportPath, connection.service(reportPath), {
    methods: reportMethods
  });
};

// src/services/badge/badge.shared.ts
var badgePath = "/report/v1/:tenantId/badge";
var badgeMethods = ["generateBadge"];
var badgeClient = (client) => {
  const connection = client.get("connection");
  client.use(badgePath, connection.service(badgePath), {
    methods: badgeMethods
  });
};

// src/client.ts
var createClient = (connection, authenticationOptions = {}) => {
  const client = feathers();
  client.configure(connection);
  client.configure(authenticationClient(authenticationOptions));
  client.set("connection", connection);
  client.configure(reportClient);
  client.configure(badgeClient);
  return client;
};
export {
  createClient
};
//# sourceMappingURL=client.js.map